export const SCORE_TYPE = {
  RACE: 'race',
  PRACTICE: 'practice',
};